/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FacultyContactInformationDTO
 */
export interface FacultyContactInformationDTO {
	/**
	 *
	 * @type {string}
	 * @memberof FacultyContactInformationDTO
	 */
	id?: string;
	/**
	 *
	 * @type {string}
	 * @memberof FacultyContactInformationDTO
	 */
	contactPersonName?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof FacultyContactInformationDTO
	 */
	email?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof FacultyContactInformationDTO
	 */
	phone?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof FacultyContactInformationDTO
	 */
	nameRo?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof FacultyContactInformationDTO
	 */
	nameEn?: string | null;
}

export function FacultyContactInformationDTOFromJSON(
	json: any
): FacultyContactInformationDTO {
	return FacultyContactInformationDTOFromJSONTyped(json, false);
}

export function FacultyContactInformationDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): FacultyContactInformationDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		id: !exists(json, "id") ? undefined : json["id"],
		contactPersonName: !exists(json, "contactPersonName")
			? undefined
			: json["contactPersonName"],
		email: !exists(json, "email") ? undefined : json["email"],
		phone: !exists(json, "phone") ? undefined : json["phone"],
		nameRo: !exists(json, "nameRo") ? undefined : json["nameRo"],
		nameEn: !exists(json, "nameEn") ? undefined : json["nameEn"],
	};
}

export function FacultyContactInformationDTOToJSON(
	value?: FacultyContactInformationDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		id: value.id,
		contactPersonName: value.contactPersonName,
		email: value.email,
		phone: value.phone,
		nameRo: value.nameRo,
		nameEn: value.nameEn,
	};
}
